import React, { useContext, useState } from 'react';
import RouteContext from '../contexts/RouteContext';
import StopsContext from '../contexts/StopsContext';
import { Button, TextField, FormControl } from '@mui/material';
import PWDService from '../utils/apiClient';
import FieldActivity from '../classes/FieldActivity';
import ContainerRoute from '../classes/ContainerRoute';

const RouteSelectDebug = () => {

    const [routeNumber, setRouteNumber] = useState('');
    const [routeDate, setRouteDate] = useState('');
    const routeContext = useContext(RouteContext);
    const stopsContext = useContext(StopsContext);

    const handleRouteNumberChange = (event) => {
        setRouteNumber(event.target.value);
    };
    const handleRouteDateChange = (event) => {
        setRouteDate(event.target.value);
    };

    const handleClick = (event) => {
        const stops = [];

        const fetchData = async () => {
            const result = await PWDService.getRouteStopsForDate(routeNumber, routeDate);
            return result;

        };
        fetchData().then((value) => {
            console.log("get stops api call: ", value);

            let containerRoute = new ContainerRoute(value.id, value.routeDate, value.routeNumber);
            routeContext.setContainerRoute(containerRoute);

            for(let i in value.stops){
                let fieldActivity = new FieldActivity(value.stops[i]);
                stops.push(fieldActivity);
            }
            stopsContext.setStops(stops);
        });
    };

    return (
        <FormControl noValidate autoComplete="off">
            <TextField id="route-number-debug" value={routeNumber} label="Route Number" onChange={handleRouteNumberChange}/>
            <TextField id="route-date-debug" value={routeDate} label="Route Date" onChange={handleRouteDateChange}/>
            <Button variant="contained" color="primary" onClick={handleClick}>Go</Button>
        </FormControl>
    );

};

export default RouteSelectDebug;